import { NavLink, Route, Routes, useLocation } from "react-router-dom";
import { Column, Grid } from "@carbon/react";

import {
  homeNavLinks,
  mainNavLinks,
  paymentsNavLinks,
  balancesNavLinks,
  settingsNavLinks,
  reportsNavLinks,
  customersNavLinks,
  productsNavLinks,
  checkoutpaymentLink,
  paymentmethodsLink,
  invoicetemplateLink,
  subemailLink,
  accountdetailsLink,
  businessdetailsLink,
  bankaccountpayoutLink,
  brandingLink,
  reportdocumentLink,
  teamsecurityLink,
  externalaccountLink,
} from "../../routes";
import { HoverDropDown } from "../HoverDropDown";
import { PageTabNavLinks } from "../PageTabNavLinks";
import { Home, LinkedExternalAcctLink } from "../../pages";
import { PaymentsLayout } from "./PaymentsLayout";
import { BalancesLayout } from "./BalancesLayout";
import { SettingsLayout } from "./SettingsLayout";
import { ReportsLayout } from "./ReportsLayout";
import { CustomersLayout } from "./CustomersLayout";
import { ProductsLayout } from "./ProductsLayout";
import { CheckoutPaymentLinkLayout } from "./CheckoutPaymentLinkLayout";
import { PaymentMethodsLinkLayout } from "./PaymentMethodsLinkLayout";
import { InvoiceTemplateLinkLayout } from "./InvoiceTemplateLinkLayout";
import { SubAndEmailLinkLayout } from "./SubAndEmailLinkLayout";
import { AccountDetailsLinkLayout } from "./AccountDetailsLinkLayout";
import { BusinessDetailsLinkLayout } from "./BusinessDetailsLinkLayout";

import calendarIcon from "../../assets/icons/calendar.svg";
import { BankPayoutLinkLayout } from "./BankPayoutLinkLayout";
import { ReportDocumentLinkLayout } from "./ReportDocumentLinkLayout";
import { BrandingLinkLayout } from "./BrandingLinkLayout";
import { TeamSecurityLinkLayout } from "./TeamSecurityLinkLayout";
import { LinkedAccountLayout } from "./LinkedAccountLayout";


export const View = () => {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/");
  const breadcrumbPaths = splitPath.map((part, i) => ({
    path: splitPath.slice(1, i + 1).join("/"),
    pathFragment: part,
  }));
  const visibleTabNavLinks = mainNavLinks.filter((link) => !link.isShowMore);
  const hiddenTabNavLinks = mainNavLinks.filter((link) => link.isShowMore);

  return (
    <Grid className="dashboard" fullWidth>
      <Column lg={16} md={0} sm={0} className="dashboard__nav">
        <Grid className="main-route--container">
          {/* Pull left nav links */}
          <Column lg={13} md={5} sm={4} className="main-route--tabs">
            {visibleTabNavLinks.map((link) => (
              <NavLink
                key={link.route}
                to={link.route}
                className="main-tab--link button--link"
              >
                {link.name}
              </NavLink>
            ))}

            <HoverDropDown
              text="More"
              className="main-tab--link"
              contentClassName="more-content"
            >
              {hiddenTabNavLinks.map((link) => (
                <NavLink
                  key={link.route}
                  to={link.route}
                  className="more-content--container"
                >
                  <div className="more-content--link">
                  <img
                          src={link.icon}
                          className="link-icon align-icon--center"
                          alt="link icon"
                        />
                       
                    <span className="link-name">{link.name}</span>
                  </div>
                </NavLink>
              ))}
            </HoverDropDown>
          </Column>

          {/* Pull right nav links *** its been a wonderful experience, 
          the fact the i was given opportunity
          to learn and improve myself is what mgrateful for. have 
          had this experience sometimes last year so the settings is 
          not kind of new just that have gained more knowledge like 
          how to do collaborative work, how  to keep track of the progress 
          of the project and for this, ill keep on learning and improving myself  */}
          <Column
            lg={{ span: 2, offset: 14 }}
            md={0}
            sm={0}
            className="pull-right"
          >
            <NavLink className="main-tab--link" to="/developers">
              Developers
            </NavLink>
            <NavLink className="main-tab--link" to="/settings">
              Settings
            </NavLink>
          </Column>
        </Grid>
      </Column>

      {/* Mobile */}


      <Routes>
        <Route
          path="/"
          element={
            <>
              <PageTabNavLinks pageTabNavLinks={homeNavLinks} />
              <Column lg={16} md={8} sm={4} className="page-content">
                <Home />
              </Column>
            </>
          }
        />

        <Route
          path="payments/*"
          element={
            <>
              <PageTabNavLinks pageTabNavLinks={paymentsNavLinks} />
              <Column lg={16} md={8} sm={4} className="page-content">
                <PaymentsLayout />
              </Column>
            </>
          }
        />

        <Route
          path="balances/*"
          element={
            <>
              <PageTabNavLinks pageTabNavLinks={balancesNavLinks} />
              <Column lg={16} md={8} sm={4} className="page-content">
                <BalancesLayout />
              </Column>
            </>
          }
        />
        <Route path="reports/*" 
        element={
          <>
          <PageTabNavLinks pageTabNavLinks={reportsNavLinks} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <ReportsLayout/>
            </Column>
            </>
        }
          />
        <Route path="/customers" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={customersNavLinks} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <CustomersLayout/>
            </Column>
            </>
        }
         />

<Route path="/products" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={productsNavLinks} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <ProductsLayout/>
            </Column>
            </>
        }
         />

        <Route path="/developers" element={<>Devs</>} />

        
        <Route
            path="/settings"
            element={<>
              <PageTabNavLinks pageTabNavLinks={settingsNavLinks} />
              <Column lg={16} md={8} sm={4} className="page-content">
                <SettingsLayout />
              </Column>
            </>} 
            />
            {/* SETTINGS LINKS */}

            <Route path="/checkout-and-payment-links" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={checkoutpaymentLink} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <CheckoutPaymentLinkLayout/>
            </Column>
            </>
        }
         />

        <Route path="/payment-methods" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={paymentmethodsLink} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <PaymentMethodsLinkLayout/>
            </Column>
            </>
        }
         />

<Route path="/invoice-template" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={invoicetemplateLink} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <InvoiceTemplateLinkLayout/>
            </Column>
            </>
        }
         />

<Route path="/subscriptions-and-emails" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={subemailLink} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <SubAndEmailLinkLayout/>
            </Column>
            </>
        }
         />

<Route path="/account-details" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={accountdetailsLink} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <AccountDetailsLinkLayout/>
            </Column>
            </>
        }
         />
         <Route path="/business-details" 
        element={
        <>
        <PageTabNavLinks pageTabNavLinks={businessdetailsLink} />
          <Column lg={16} md={8}sm={4} className="page-content">
            <BusinessDetailsLinkLayout/>
            </Column>
            </>
        }
         />
        <Route path="/accounts-and-currencies"
        element={
          <>
          <PageTabNavLinks pageTabNavLinks={bankaccountpayoutLink} />
            <Column lg={16} md={8}sm={4} className="page-content">
              <BankPayoutLinkLayout/>
              </Column>
              </>
          }
           />


        <Route path="/branding"
        element={
          <>
          <PageTabNavLinks pageTabNavLinks={brandingLink} />
            <Column lg={16} md={8}sm={4} className="page-content">
              <BrandingLinkLayout/>
              </Column>
              </>
          }
           />
           
          
        <Route path="/reporting"
        element={
          <>
          <PageTabNavLinks pageTabNavLinks={reportdocumentLink} />
            <Column lg={16} md={8}sm={4} className="page-content">
              <ReportDocumentLinkLayout/>
              </Column>
              </>
          }
           />

        <Route path="/team-members"
        element={
          <>
          <PageTabNavLinks pageTabNavLinks={teamsecurityLink} />
            <Column lg={16} md={8}sm={4} className="page-content">
              <TeamSecurityLinkLayout/>
              </Column>
              </>
          }
           />

<Route path="/linked-accounts"
        element={
          <>
          <PageTabNavLinks pageTabNavLinks={externalaccountLink} />
            <Column lg={16} md={8}sm={4} className="page-content">
              <LinkedAccountLayout/>
              </Column>
              </>
          }
           />
      </Routes>
    </Grid>
  );
};
